import { register } from '@/plugin/popup'

export default {
  mounted() {
    register({
      name: this.popupName,
      open: (opt) => {
        this.afterClose = opt.afterClose
        this.openAction(opt)
      },
      close: this.close
    })
  },
  methods: {
    close() {
      this.closeAction()
      this.dealClose()
    },
    dealClose() {
      const { afterClose } = this
      if (afterClose) {
        afterClose()
      }
    }
  }
}
